import { baseURL } from "../../configurations/environment";
import { RequestConfig } from "../RequestConfig";
import { createRequest } from "helpers/tools";

export const getBusinessSelectedAsync = async (id) => {
    return await createRequest({
        suffix: `user/businesses/${id}`,
        method: "get",
        handleError: false,
    });
};

export const getPiiData = async () => {
    const requestURL = baseURL + `/api/user/pii`;
    let responseResult = {
        status: "",
        message: "",
        data: "",
    };
    try {
        const response = await fetch(requestURL, RequestConfig());

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        responseResult = {
            status: true,
            message: data.message || "",
            data: data.data || "",
        };

        window.dataLayer.push({
            event: "data",
            url: window.location.pathname,
            hashedEmail: data.data?.email,
            hashedName: data.data?.firstname,
            hashedSurname: data.data?.lastname,
        });
    } catch (error) {
        responseResult = {
            status: false,
            message: error.message || "An error occurred",
        };
    }

    return responseResult;
};

export const startSubscriptionAsync = async (payload) => {
    return await createRequest({
        suffix: "subscription/start",
        handleError: false,
        method: "post",
        payload,
    });
};
